import { func } from "prop-types";
import React from "react";
import Modal from "react-modal";
import { Button } from "../../../common/Button/Button";
import { ControlledInput } from "../../../common/Input/Input";
import ModalContent from "../../../common/Modal/ModalContent";
import { X } from "react-feather";
import Checkbox from "../../../common/Checkbox/Checkbox";
import Spinner from "../../../common/Spinner/Spinner";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";

Modal.setAppElement("#root");

export default function RefundModal({refundDetails,...props})
{
    return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent className="refund-modal">
				{props.isLoading && <Spinner className="center" />}
				<div className="p-2 modal-headers-bar">
					<span>Refund Details</span>
					<button
						id="lpmRefundCloseButton"
						type="button"
						className="close"
						aria-label="Close"
						onClick={props.toggleModal}
					>
						<X style={{ pointerEvents: "none" }} color="white" />
					</button>
				</div>
				<div
					className={`modal-body ${props.isDisabled} ${props.isLoading && "set-opacity"}
					${props.service["bRefund"]? "disable": ""} `}
				>
					<div className='form-group'>
						<div className='row'>
							<div className="col-md-12">
								<div style={{float:"left",marginTop:"4px"}}>
								<Checkbox
									id="Refund"
									checked={refundDetails.bRefund || false}
									onChange={(e) => {
										e.stopPropagation();
										props.onInputChange(
											"bRefund",
											!refundDetails.bRefund
										);
									}}
									label=" Is Refunded"
									onClick={(e) => {
										e.stopPropagation();
									}}
								/>
								</div>
								
								<span>Refund date:</span>
								<ReactDatePicker
									dateFormat="dd/MM/yyyy"
									selected={refundDetails.dtRefunded || ""}
									onChange={(date) =>
										props.onInputChange("dtRefunded", date)
									}
									maxDate={new Date()}
									style={{width:"30px"}}
								/>
							</div>
						</div>
					</div>
					<span>Refund comment:</span>
					<div className="form-group">
						{/*<ControlledInput
							name="sRefundComment"
							label="Refund comment:"
							value={refundDetails.sRefundComment || ""}
							onChange={({ target: { name, value } }) =>
								props.onInputChange(name, value)
							}
							onClick={(e) => {
								e.stopPropagation();
							}}
						// required
						/>*/}
						<textarea
							name="sRefundComment"
							label="Refund comment:"
							className="w-100 form-control rounded"
							value={refundDetails.sRefundComment || ""}
							onChange={({ target: { name, value } }) =>
								props.onInputChange(name, value)
							}
							style={{minHeight:"95px"}}
						/>
					</div>
					<span>Cancellation reason:</span>
					<Select
						className={`mb-2   ${
							props.service["refCurrentState"]["sServiceState"] === "Cancelled"
								? "disabled"
								: ""
						}`}
						options={props.cancellationReasonDropdownOptions}
						onChange={props.onSelectCancellationReasonforRefund}
						value={props.selectedCancellationReasonforRefund}
						isClearable
						isDisabled=	{
										props.service["refCurrentState"]["sServiceState"] === "Cancelled"?
										true:false
									}
					/>
					{props.enableOtherDescriptionTextboxforRefund ? (
						<ControlledInput
							className={
								props.service["refCurrentState"]["sServiceState"] === "Cancelled"
									? "disabled"
									: ""
							}
							placeholder="Please specify a reason here"
							// onChange={(event) => { event.persist();debounce(() => {props.onSearchInputChange(event)},1000)}}
							onChange={({ target }) =>
								props.onChangeCancellationReasonOtherDescriptionforRefund(
									target.value
								)
							}
							value={props.cancellationReasonOtherDescriptionforRefund}
							isDisabled=	{
								props.service["refCurrentState"]["sServiceState"] === "Cancelled"?
								true:false
							}
						/>
					) : (
						<>
						</>
					)}
                    
					
					<div className="mt-4">
						<Button
							id="spmRefundSave"
							onClick={props.onSaveRefundDetails}
						>
							Save Refund
						</Button>
						<span
							id="spmRefundCancel"
							className="ml-2 cursor-pointer"
							onClick={props.toggleModal}
						>
							Cancel
						</span>
					</div>
				</div>
			</ModalContent>
		</Modal >
	);
}